export const path = "/it-request";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "PEDIDOS IT",
  section: "IONVO",
  group: null,
  order: 1,
  roles: [
    "Authenticated",
    "roundler-admin",
    "aluna",
    "aluna-management",
    "hop-management",
    "design",
    "design-roundler",
    "aluna-afiliado",
  ],
};
